// Module
var code = "<div class=\"loader__header\"> <div class=\"loader__header__text neumatic p2 animated-text animated-text--z\" data-entrance-delegated=\"true\" data-splitted=\"true\"> <div class=\"animated-text__wrapper\"> <div class=\"animated-text__row\"></div> </div> </div> </div> ";
// Exports
export default code;